import loadJs from "./load.js";


export default {

    isMobile() {
        return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)

    },
    init(functionSuccess) {




        return ;
        try {
            let userAgent = navigator.userAgent;
            if (userAgent.indexOf("AlipayClient") > -1) {
                loadJs.js("https://appx/web-view.min.js" , functionSuccess);
            } else if (/QQ/i.test(userAgent) && /miniProgram/i.test(userAgent)) {
                loadJs.js("https://qqq.gtimg.cn/miniprogram/webview_jssdk/qqjssdk-1.0.0.js", functionSuccess);
            } else if (/miniProgram/i.test(userAgent)) {
                loadJs.js("https://res.wx.qq.com/open/js/jweixin-1.4.0.js", functionSuccess);
            } else if (/toutiaomicroapp/i.test(userAgent)) {
                loadJs.js("https://s3.pstatp.com/toutiao/tmajssdk/jssdk-1.0.1.js", functionSuccess);
            } else if (/swan/i.test(userAgent)) {
                loadJs.js("https://b.bdstatic.com/searchbox/icms/searchbox/js/swan-2.0.18.js", functionSuccess);
            }

            loadJs.js("https://oss2.1dq.com/app/static/js/client.js")
            // if (!/toutiaomicroapp/i.test(userAgent)) {
            //     this.TTConfig(functionSuccess);
            // }

        } catch (e) {
            console.log(e);
        }
    },
    TTConfig(functionSuccess) {
        try {
            document.querySelector(".post-message-section").style.visibility = "visible";
            functionSuccess();
        } catch (e) {
            console.log(e);
        }
    }
};
